import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './publicacion_renovar.css';

const PublicacionRenovar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { idAviso } = location.state || {};

  const [saldoActual, setSaldoActual] = useState(0);
  const [planSeleccionado, setPlanSeleccionado] = useState('');
  const [planActual, setPlanActual] = useState(null);
  const [fechaVencimientoActual, setFechaVencimientoActual] = useState(null);
  const [planes, setPlanes] = useState({ premium: [], destacado: [] });
  const [loading, setLoading] = useState(true);
  const [showPopupExito, setShowPopupExito] = useState(false);
  const [showModalPendiente, setShowModalPendiente] = useState(false);
  const [mensajePendiente, setMensajePendiente] = useState('');
  const [cancelandoPendiente, setCancelandoPendiente] = useState(false);

const featuresMap = {
    ASP: ['7 días de publicación', 'Sin pausas', 'Apareces en el inicio de la página', '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras', 'Creación de historias y uso de agenda', 'Vencimiento: 7 días'],
    AMP: ['30 días de publicación', '[PAUSA] Hasta 120 horas (5 días) acumulables', 'Apareces en el inicio de la página', '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras', 'Creación de historias y uso de agenda', 'Vencimiento sin pausas: 30 días', 'Vencimiento usando todas las pausas: 35 días'],
    ADP: ['60 días de publicación', '[PAUSA] Hasta 240 horas (10 días) acumulables', 'Apareces en el inicio de la página', '[PREMIUM] Tu aviso e historias aparecen en los perfiles de OTRAS publicadoras', 'Creación de historias y uso de agenda', 'Vencimiento sin pausas: 60 días', 'Vencimiento usando todas las pausas: 70 días'],
    ASD: ['7 días de publicación', 'Sin pausas disponibles', 'Apareces en el inicio de la página', 'Tus historias son visibles en el banner del inicio de la página', 'Creación de historias y uso de agenda', 'Vencimiento: 7 días'],
    AMD: ['30 días de publicación', 'Sin pausas disponibles', 'Apareces en el inicio de la página', 'Tus historias son visibles en el banner del inicio de la página', 'Creación de historias y uso de agenda', 'Vencimiento: 30 días'],
    ADD: ['60 días de publicación', 'Sin pausas disponibles', 'Apareces en el inicio de la página', 'Tus historias son visibles en el banner del inicio de la página', 'Creación de historias y uso de agenda', 'Vencimiento: 60 días'],
  };

  useEffect(() => {
    cargarDatosAviso();
  }, []);

  const cargarDatosAviso = async () => {
    try {
      setLoading(true);

      // 1. Cargar plan actual
      const responsePlan = await fetch(
        `${process.env.REACT_APP_PUBLICACION_PAUSA_URL}/get_publicacionpausa.php?id_publicacion=${idAviso}`,
        { method: 'GET', credentials: 'include' }
      );
      const dataPlan = await responsePlan.json();
      if (dataPlan.success) {
        const d = dataPlan.data;
        setPlanActual(d);
        setFechaVencimientoActual(d.fecha_vencimiento);
      }

      // 2. Cargar saldo
      const responseSaldo = await fetch(
        `${process.env.REACT_APP_SALDO_DEV_URL}/get_consultasaldo.php`,
        { method: 'GET', credentials: 'include' }
      );
      const dataSaldo = await responseSaldo.json();
      if (dataSaldo.success) setSaldoActual(dataSaldo.saldo_actual);

      // 3. Cargar planes disponibles
      const responsePlanes = await fetch(
        `${process.env.REACT_APP_SALDO_DEV_URL}/get_planes.php`,
        { method: 'GET', credentials: 'include' }
      );
      const dataPlanes = await responsePlanes.json();
      if (dataPlanes.success) setPlanes({ premium: dataPlanes.premium, destacado: dataPlanes.destacado });

    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionarPlan = (planId) => {
    setPlanSeleccionado(planId);
  };

const getFechaInicio = () => {
    if (!fechaVencimientoActual) return '—';
    const fecha = new Date(fechaVencimientoActual);
    return fecha.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getPlanData = (planId) => {
    const todosPlanes = [...planes.premium, ...planes.destacado];
    return todosPlanes.find(p => p.id === planId);
  };

  const handleCancelar = () => {
    navigate('/gestion_avisos');
  };

const handleConfirmar = async () => {
    if (!planSeleccionado) {
      alert('Debes seleccionar un plan');
      return;
    }

    const plan = getPlanData(planSeleccionado);
    
    if (saldoActual < plan.precio) {
      alert(`❌ Saldo insuficiente. Necesitas $${plan.precio.toLocaleString('es-CL')}\nTu saldo: $${saldoActual.toLocaleString('es-CL')}`);
      return;
    }

try {
      const response = await fetch(
        `${process.env.REACT_APP_PUBLICACION_RENOVAR_URL}/post_renovar.php`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id_publicacion: idAviso,
            codigo_plan: planSeleccionado
          })
        }
      );
const data = await response.json();
      if (!data.success) {
        if (data.requiere_cancelacion) {
          setMensajePendiente(data.message);
          setShowModalPendiente(true);
          return;
        }
        alert(`❌ ${data.message}`);
        return;
      }
      setShowPopupExito(true);
      setTimeout(() => {
        setShowPopupExito(false);
        navigate('/gestion_avisos');
      }, 10000);
    } catch (error) {
      console.error('Error al renovar:', error);
      alert('Error al procesar la renovación. Intenta nuevamente.');
    }
  };

  const handleCancelarPendiente = async () => {
    setCancelandoPendiente(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PUBLICACION_RENOVAR_URL}/post_cancelar_renovacion.php`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id_publicacion: idAviso })
        }
      );
      const data = await response.json();
      if (!data.success) {
        alert(`❌ ${data.message}`);
        return;
      }
      setShowModalPendiente(false);
      setPlanSeleccionado('');
      const responseSaldo = await fetch(
        `${process.env.REACT_APP_SALDO_DEV_URL}/get_consultasaldo.php`,
        { method: 'GET', credentials: 'include' }
      );
      const dataSaldo = await responseSaldo.json();
      if (dataSaldo.success) setSaldoActual(dataSaldo.saldo_actual);
    } catch (error) {
      console.error('Error al cancelar renovacion pendiente:', error);
      alert('Error al cancelar la renovación pendiente. Intenta nuevamente.');
    } finally {
      setCancelandoPendiente(false);
    }
  };

  const planSeleccionadoData = planSeleccionado ? getPlanData(planSeleccionado) : null;

  return (
    <>
      <div className="renovar-container">
      <div className="renovar-content">
        {/* HEADER */}
        <div className="renovar-header">
          <h2 className="renovar-titulo">♻️ RENOVAR PLAN</h2>
          <button className="renovar-close" onClick={handleCancelar}>×</button>
        </div>

        {/* BODY */}
        <div className="renovar-body">
{/* ALERTA */}
          {planActual && planActual.dias_restantes <= 3 && (
            <div className="alert-box">
              <strong>⚠️ Tu plan vence en {planActual.dias_restantes} día(s)</strong>
            </div>
          )}

{/* RESUMEN PLAN ACTUAL */}
          <div className="info-box">
            <div className="info-box-title">📊 Resumen de tu plan actual</div>
            <div className="info-box-content">
              {loading ? 'Cargando...' : planActual ? (
                <>
                  <strong>Plan:</strong> {planActual.plan_nombre}<br/>
                  <strong>Días usados:</strong> {planActual.dias_publicados}/{planActual.dias_totales}<br/>
                  <strong>Días restantes:</strong> {planActual.dias_restantes} días<br/>
                  <strong>Vencimiento:</strong> {getFechaInicio()}
                </>
              ) : 'No se pudo cargar la información del plan.'}
            </div>
          </div>

          {/* ELIGE TU PRÓXIMO PLAN */}
          <h3 className="seccion-titulo">🎯 Elige tu próximo plan:</h3>

          {/* PLANES PREMIUM */}
          <h4 className="categoria-titulo categoria-premium">PLANES PREMIUM</h4>
          <div className="planes-grid">
            {planes.premium.map(plan => (
              <div 
                key={plan.id}
                className={`plan-card ${planSeleccionado === plan.id ? 'plan-selected' : ''}`}
                onClick={() => handleSeleccionarPlan(plan.id)}
              >
                <div className="plan-header">
                  <div>
                    <div className="plan-nombre">{plan.nombre}</div>
                    <div className="plan-precio">${plan.precio.toLocaleString('es-CL')}</div>
                  </div>
                  <div className={`radio-circle ${planSeleccionado === plan.id ? 'radio-selected' : ''}`}></div>
                </div>
<ul className="plan-features">
                  {(featuresMap[plan.id] || []).map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                  <li className="plan-inicio">📅 Inicio automático al vencer tu plan actual: {getFechaInicio()}</li>
                </ul>
              </div>
            ))}
          </div>

          {/* PLANES DESTACADOS */}
          <h4 className="categoria-titulo categoria-destacados">PLANES DESTACADOS</h4>
<div className="planes-grid">
            {planes.destacado.map(plan => (
              <div 
                key={plan.id}
                className={`plan-card ${planSeleccionado === plan.id ? 'plan-selected' : ''}`}
                onClick={() => handleSeleccionarPlan(plan.id)}
              >
                <div className="plan-header">
                  <div>
                    <div className="plan-nombre">{plan.nombre}</div>
                    <div className="plan-precio">${plan.precio.toLocaleString('es-CL')}</div>
                  </div>
                  <div className={`radio-circle ${planSeleccionado === plan.id ? 'radio-selected' : ''}`}></div>
                </div>
                <ul className="plan-features">
                  {(featuresMap[plan.id] || []).map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                  <li className="plan-inicio">📅 Inicio automático: {getFechaInicio()}</li>
                </ul>
              </div>
            ))}
          </div>

          {/* RESUMEN DE PAGO */}
          <div className="pago-box">
            <div className="pago-title">💰 Resumen de Pago</div>
            <div className="pago-row">
              <span className="pago-label">Costo plan:</span>
              <span className="pago-valor">
                ${planSeleccionadoData ? planSeleccionadoData.precio.toLocaleString('es-CL') : '0'}
              </span>
            </div>
            <div className="pago-row">
              <span className="pago-label">Tu saldo:</span>
              <span className="pago-valor gratis">${saldoActual.toLocaleString('es-CL')} ✅</span>
            </div>
            <div className="pago-row total">
              <span className="pago-label">Saldo después:</span>
              <span className="pago-valor">
                ${planSeleccionadoData ? (saldoActual - planSeleccionadoData.precio).toLocaleString('es-CL') : saldoActual.toLocaleString('es-CL')}
              </span>
            </div>
          </div>

          {planSeleccionadoData && (
            <div className="fecha-cobro">
              Se cobrará automáticamente el <strong>{planSeleccionadoData.fechaInicio}</strong>
            </div>
          )}
        </div>

        {/* Popup renovacion pendiente existente */}
      {showModalPendiente && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 99999,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: 'white', borderRadius: '16px', padding: '40px',
            maxWidth: '520px', width: '90%', textAlign: 'center',
            border: '4px solid #53120C', boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h2 style={{
              fontFamily: 'Arial Black, Arial, sans-serif',
              color: '#53120C', fontSize: '22px', marginBottom: '16px'
            }}>
              Ya tienes una renovación programada
            </h2>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '16px', color: '#333', lineHeight: 1.6 }}>
              {mensajePendiente}
            </p>
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'center' }}>
              <button
                className="btn-cancelar"
                onClick={() => setShowModalPendiente(false)}
                disabled={cancelandoPendiente}
              >
                Mantener mi renovación actual
              </button>
              <button
                className="btn-confirmar"
                onClick={handleCancelarPendiente}
                disabled={cancelandoPendiente}
              >
                {cancelandoPendiente ? 'Cancelando...' : 'Cancelar y elegir otro plan'}
              </button>
            </div>
          </div>
        </div>
      )}

        {/* FOOTER */}
<div className="renovar-footer">
          <button className="btn-cancelar" onClick={handleCancelar}>
            Cancelar
          </button>
          {planSeleccionadoData && saldoActual < planSeleccionadoData.precio ? (
            <button
              className="btn-confirmar"
              style={{ backgroundColor: '#aaa', cursor: 'not-allowed' }}
              onClick={() => alert('Saldo insuficiente. Agrega saldo antes de renovar.')}
            >
              ♻️ Saldo insuficiente
            </button>
          ) : (
            <button className="btn-confirmar" onClick={handleConfirmar}>
              ♻️ Programar Renovación
            </button>
          )}
        </div>
      </div>
</div>

{/* Popup éxito renovación */}
      {showPopupExito && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 99999,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: 'white', borderRadius: '16px', padding: '40px',
            maxWidth: '520px', width: '90%', textAlign: 'center',
            border: '4px solid #008000', boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <h2 style={{
              fontFamily: 'Arial Black, Arial, sans-serif',
              color: '#008000', fontSize: '22px', marginBottom: '16px'
            }}>
              ¡Renovación Programada!
            </h2>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: '16px', color: '#333', lineHeight: 1.6 }}>
              Gracias por adquirir tu nuevo plan.<br/>
              Este será activado automáticamente una vez que termine tu plan actual.
            </p>
            <p style={{
              fontFamily: 'Arial Black, Arial, sans-serif',
              fontSize: '18px', color: '#53120C', margin: '20px 0',
              fontWeight: '900'
            }}>
              Fecha de inicio: {getFechaInicio()}
            </p>
            <p style={{ fontSize: '13px', color: '#999', fontStyle: 'italic' }}>
              Serás redirigido en 10 segundos...
            </p>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default PublicacionRenovar;
